import React from 'react';
import './App.css';

import { BrowserRouter as Router,Route,Routes} from 'react-router-dom';
// import { Routes } from 'react-router';
// import Sidebar from './components/Sidebar';
import Home from './pages';
import SigninPage from './pages/signin';
function App() {
  return (
    <Router>
    <Routes>
     <Route path="/" element={<Home/>} exact /> 
     <Route path="/signin" element={<SigninPage/>} exact /> 
    </Routes>
    </Router>
  );
}

export default App;
